import { render } from "./BehaviorChart.vue?vue&type=template&id=3012aac8&scoped=true"
import script from "./BehaviorChart.vue?vue&type=script&lang=ts"
export * from "./BehaviorChart.vue?vue&type=script&lang=ts"

import "./BehaviorChart.vue?vue&type=style&index=0&id=3012aac8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3012aac8"

export default script